import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page } from '../../components';
import TrainerSidebar from '../../components/TrainerSidebar/TrainerSidebar';
import ClientList from '../../components/ClientList/ClientList';
import css from './ClientListPage.module.css';

export const ClientListPageComponent = props => {
  const { scrollingDisabled, currentUser, notifications } = props;
  const unreadCount = notifications?.filter(n => !n.read)?.length || 0;

  return (
    <Page title="Client Roster — GymNet" scrollingDisabled={scrollingDisabled}>
      <div className={css.layout}>
        <TrainerSidebar
          currentPage="ClientListPage"
          currentUser={currentUser}
          unreadCount={unreadCount}
        />
        <main className={css.content}>
          <ClientList currentUser={currentUser} />
        </main>
      </div>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { notifications } = state.user || {};
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    notifications,
  };
};

const ClientListPage = compose(
  connect(mapStateToProps),
  injectIntl
)(ClientListPageComponent);

export default ClientListPage;
